import IncidentTypes from "../constants/IncidentTypes";
import { RouteConstants } from "../constants/RouteConstants";
import TrackingAccuracyReportStore from "./trackingAccuracyReportStore";

class InternationalIndependentTrackingAccuracyReportStore extends TrackingAccuracyReportStore {
  fetchTrackingAccuracyReport() {
    return this.veracityApi.fetchInternationalIndependentTrackingAccuracyReport(
      this.get("date"),
    );
  }

  cancelTrackingAccuracyReport() {
    return this.veracityApi.cancelInternationalIndependentTrackingAccuracyReport();
  }

  isTrackingTabActive() {
    return this.routerStore.isInternationalIndependentTrackingAccuracyReportTab;
  }

  updateNewIncidentMetadata(game) {
    return this.veracityStore.updateNewIncidentMetadata(
      IncidentTypes.InternationalIndependent,
      game,
      this.get("date"),
      RouteConstants.INDEPENDENT_INTERNATIONAL_TRACKING,
    );
  }
}

export default InternationalIndependentTrackingAccuracyReportStore;
